// extracted by mini-css-extract-plugin
export default {"wrapper":"HN","content":"IN","firstSection":"JN","text":"KN","table":"LN","tableText":"MN","row":"NN","column_2":"ON","column_1":"PN","column_3":"QN"};
    if(module.hot) {
      // 1715632478268
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  